var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Tabs',{staticClass:"empty-tab",on:{"input":_vm.changeTab},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.authorizedTabs),function(item,index){return _c('Tab',{key:`tab-${index}`,attrs:{"header":item.label}})}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }